import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/firebase";

export const createLog = async ({
  ticket,
  action,
  message,
  user,
  metadata = {}
}) => {
  try {
    await addDoc(collection(db, "logs"), {
      ticket_id: ticket.id,
      ticket_number: ticket.ticketNumber,
      action,
      message,
      user_id: user.uid,
      user_name: user.name,
      user_role: user.role,
      metadata,
      created_at: serverTimestamp(),
    });
  } catch (err) {
    console.error("Log error:", err);
  }
};
